<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>外文官网</el-breadcrumb-item>
        <el-breadcrumb-item>游戏管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="operating">
      <router-link :to="{path: 'languageGameStore'}">
        <el-button
          type="primary"
          size="small"
        >新增游戏</el-button>
      </router-link>
    </div>
    <div >
      <template>
        <el-table
          :data="tableData"
          stripe
          center
          border
          highlight-current-row
          style="width: 100%">
          <el-table-column
            align="center"
            label="排序"
            width="80">
            <template slot-scope="scope">
              <el-input  size="small" v-model="scope.row.sequence" @change="changeSort(scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="language"
            :formatter="languageFormatter"
            label="所属官网">
          </el-table-column>
          <el-table-column
            align="center"
            prop="name"
            label="游戏名称">
          </el-table-column>
          <el-table-column
            align="center"
            label="上架状态">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.status?'上架':'下架'" placement="top">
                <el-switch
                  v-model="scope.row.status"
                  @change="handleChangeStatus(scope.row)"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6">
                </el-switch>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="240">
            <template slot-scope="scope" >
              <router-link :to="{path: 'languageGameStore', query: {id: scope.row.id}}">
                <el-button
                  type="primary"
                  size="small"
                  >编辑</el-button>
              </router-link>
              <router-link :to="{path: 'languageGameLink', query: {id: scope.row.id, name: scope.row.name}}">
                <el-button
                  type="primary"
                  size="small"
                >链接</el-button>
              </router-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="block page-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page=page
            :page-sizes="[50, 100, 200, 500]"
            :page-size=page_size
            layout="total, sizes, prev, pager, next, jumper"
            :total=total>
          </el-pagination>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import {getGamePage, storeSort} from '../../../api/language/game'
export default {
  data () {
    return {
      tableData: [],
      page: 1,
      page_size: 50,
      total: 0,
      language: [
        {
          value: 1,
          label: '英文官网'
        },
        {
          value: 2,
          label: '韩文官网'
        }
      ]
    }
  },
  mounted () {
    // 页面数据初始化表格数据
    this.setTableData()
  },
  methods: {
    languageFormatter (row, column, cellValue, index) {
      let info = this.language.find(item => item.value === cellValue)
      return info ? info.label : '-'
    },
    // 表格填充
    setTableData () {
      getGamePage({
        page: this.page,
        page_size: this.page_size,
        type_ids: this.type_ids
      }).then(res => {
        let {status} = res
        if (status === 2000) {
          this.tableData = res.data.tableData
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
      })
    },
    // 分页大小切换回调
    handleSizeChange (val) {
      this.page_size = val
      this.setTableData()
    },
    // 页码切换回调
    handleCurrentChange (val) {
      this.page = val
      this.setTableData()
    },
    // 状态切换
    handleChangeStatus (row) {
      storeSort({
        game_id: row.id,
        status: row.status
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.setTableData()
        }
        this.$notify({
          message: message,
          type: status === 2000 ? 'success' : 'warning',
          offset: 100,
          showClose: false
        })
      })
    },
    // 排序更改
    changeSort (row) {
      storeSort({
        game_id: row.id,
        sequence: row.sequence
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.setTableData()
        }
        this.$notify({
          message: message,
          type: status === 2000 ? 'success' : 'warning',
          offset: 100,
          showClose: false
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/language/game/index.vue